import { env } from '../env';
export function resolveInput(arg) {
    if (!env.isNodejs() && typeof arg === 'string') {
        return document.getElementById(arg);
    }
    return arg;
}
//# sourceMappingURL=resolveInput.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/dom/resolveInput.js
// module id = 418
// module chunks = 0